import { AbstractResource } from './AbstractResource';

export class WorkshopSchedules extends AbstractResource {
    async fetch(customerId) {
        const { data } = await this.http.get(`/customer/${customerId}/workshop-schedule`);
        return data;
    }

    async getById(customerId, workshopScheduleId) {
        const { data } = await this.http.get(`/customer/${customerId}/workshop-schedule/${workshopScheduleId}`);
        return data;
    }

    async getTemplates(customerId) {
        const { data } = await this.http.get(`/customer/${customerId}/workshop-schedule/templates`);
        return data;
    }

    async getTypes() {
        const { data } = await this.http.get(`/workshop-schedule/types`);
        return data;
    }

    async getInputFiles() {
        const { data } = await this.http.get(`/workshop-schedule/input-file`);
        return data;
    }

    async saveWorkshopSchedule(dto, customerId, workshopScheduleId) {
        const { data } = (workshopScheduleId)
            ? await this.http.put(`/customer/${+customerId}/workshop-schedule/${workshopScheduleId}`, dto)
            : await this.http.post(`/customer/${+customerId}/workshop-schedule`, dto);

        return data;
    }

    async removeWorkshopSchedule(customerId, workshopScheduleId) {
        const { data } = await this.http.delete(`/customer/${+customerId}/workshop-schedule/${workshopScheduleId}`);
        return data;
    }

    async getOutputLines(inputFileId, offset) {
        const { data } = await this.http.get(`/input-file/${+inputFileId}/output-lines?p=${offset}`);
        return data;
    }

    async removeInputFile(id) {
        const { data } = await this.http.delete(`/workshop-schedule/input-file/${+id}`);
        return data;
    }

    async addInputFile(filename, type) {
        const { data } = await this.http.post(`/workshop-schedule/input-file`, {
            name: filename,
            type,
        });

        return data;
    }
}